import { handleActions } from "redux-actions";

import type { GeneralLedgerAccountState } from "src/interfaces/generalLedgerAccountState.interface";
import {
  DefaultAccounts,
  mapGeneralLedgerAccount,
} from "src/utils/general-ledger-accounts";

import { LOG_OUT } from "../system/actions";
import {
  FS_CREATE_ITEMS,
  FS_DELETE_ITEMS,
  FS_UPDATE_ITEMS,
  GL_ACCOUNTS,
} from "../common";
import produce from "immer";

const initialState: GeneralLedgerAccountState = {
  items: DefaultAccounts,
};

export const generalLedgerAccountReducer = handleActions<
  GeneralLedgerAccountState,
  any
>(
  {
    [GL_ACCOUNTS + FS_CREATE_ITEMS]: (state, { payload }) => {
      return produce(state, (draft) => {
        draft.items.push(
          ...payload.map((p) =>
            Array.isArray(p.type) ? p : mapGeneralLedgerAccount(p)
          )
        );
      });
    },
    [GL_ACCOUNTS + FS_DELETE_ITEMS]: (state, { payload }) =>
      produce(state, (draft) => {
        draft.items = state.items.filter(
          (item) => !payload.find((deleted) => deleted.id === item.id)
        );
      }),
    [GL_ACCOUNTS + FS_UPDATE_ITEMS]: (state, { payload }) => {
      return produce(state, (draft) => {
        for (const p of payload) {
          for (const item of draft.items) {
            if (p.id === item.id) {
              Object.assign(
                item,
                Array.isArray(p.type) ? p : mapGeneralLedgerAccount(p)
              );
              break;
            }
          }
        }
      });
    },
    [LOG_OUT]: () => initialState,
  },
  initialState
);
